import { execute } from '@/api/execute'
import { GET, POST, PUT } from '@/api/types'

const ENDPOINT = 'auth'

export default {
  /**
   * Performs user authorization
   * @param {*} payload: { email, password }
   * @returns server response with access token and user data
   */
  login (payload) {
    return execute(POST, `${ENDPOINT}/jwt/create/`, payload)
  },

  /**
   * Checks if access token is still valid
   * @param {*} payload: { token }
   * @returns server response with a token or an error
   */
  verify (payload) {
    return execute(POST, `${ENDPOINT}/jwt/verify/`, payload)
  },

  /**
   * Refresh access token
   * @param {*} payload: { token }
   * @returns server response with a new token or an error
   */
  refresh (payload) {
    return execute(POST, `${ENDPOINT}/jwt/refresh/`, payload)
  },

  /**
   * Fetchs user profile information
   * @returns server response with a user data
   */
  get () {
    return execute(GET, `${ENDPOINT}/me/`)
  },

  /**
   * Updates user profile information
   * @param {*} payload: { first_name, last_name, phone, profile }
   * @returns server response with updated data or an error
   */
  update (payload) {
    return execute(PUT, `${ENDPOINT}/me/`, payload)
  }
}
